import tilesCategories, { freeSpace } from './tiles';

export const bingoConfig = () => ({
  intro_logo: require('./img/intro.png'),
  play_now_text: 'Play Now',
  play_now_color: '#ec008c',
  bg_image: require('./img/bg-game.jpg'),
  game_logo: require('./img/logo.png'),
  how_to_play_text: 'How to play',
  how_to_play_color: '#ec008c',
  vol_on: require('./img/audio-on.png'),
  vol_off: require('./img/audio-off.png'),
  bingo_graphic: require('./img/bingo.gif'),
  refresh_text: 'Refresh',
  refresh_color: '#ec008c',
  gameboard_bg: '#d6d6d7',
  gameboard_br: '#ec008c',
  winner_line: require('./img/winner-line.png'),
  tile_hl_color: '#ec008c',
  banner_ad_img: require('./img/BANNERS.png'),
  banner_ad_link: '/node/1',
  video_url:
    '/sites/default/files/2020-04/y2mate.com%20-%20Contestants%20Try%20to%20Solve%20Blackberry%20Jam%20_%20Wheel%20of%20Fortune_AdIJ1UgNSLs_240p_1.mp4',
  bingo_page_order: ['Banner ad', 'Video', 'Game'],
});

export default () => ({ freeSpace, tilesCategories });
